module.exports = __webpack_public_path__ + "static/media/RobinCare_logo_Favicon.345e5693.png";